import * as Yup from "yup";

export function initialValues(post) {
  return {
    type: post?.type || "",
    subjectId: post?.subjectId || "",
    title: post?.title || "",
    content: post?.content || "",
  };
}

export function validationSchema() {
  return Yup.object({
    type: Yup.string()
      .nullable()
      .required("El tipo de publicación es obligatorio"),
    subjectId: Yup.string().nullable().required("La asignatura es obligatoria"),
    title: Yup.string().nullable().required("El título es obligatorio"),
    content: Yup.string().nullable().required("El contenido es obligatorio"),
  });
}
